import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastSegment'
})
export class LastSegmentPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    const parts = value.split('-');
    return parts.length > 0 ? parts[parts.length - 1] : value;
  }
}
